import type {
  ApplicationDetailsApplicantResponse,
  ApplicationType,
  CollateralType,
  DistributorApplicationDetails,
} from '@/services/application'

export const isCommitmentApplication = (type: ApplicationType) => type === 'commitmentApplication'

export const isRealEstateType = (type?: string | null) => type === 'house' || type === 'vacation'

export const getFullName = (applicant: Pick<ApplicationDetailsApplicantResponse, 'givenName' | 'surname'>) =>
  `${applicant.givenName || ''} ${applicant.surname || ''}`.trim()

export const getMainApplicant = (application: DistributorApplicationDetails) => {
  return application.applicants.find((applicant) => applicant.roles.isMainApplicant) ?? application.applicants[0]
}

export const getApplicationLtvPercentage = (application: DistributorApplicationDetails) => {
  const ltv = application.ltv.approved ?? application.ltv.appliedFor
  return ltv == null ? undefined : ltv * 100
}

export const isRealEstateCollateral = (property?: { type: CollateralType } | null) =>
  property?.type === 'house' || property?.type === 'vacation'

type TranslateFn = (key: string) => string

export const translateApplicationEnum = (
  t: TranslateFn,
  namespace: 'APPLICATION_TYPE' | 'APPLICATION_STATUS',
  rawValue?: string,
) => {
  if (!rawValue) {
    return '-'
  }

  const key = `${namespace}.${rawValue}`
  const translated = t(key)
  return translated === key ? rawValue : translated
}
